import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 2.2C4.79675 2.2 2.2 4.79675 2.2 8C2.2 11.2033 4.79675 13.8 8 13.8C11.2033 13.8 13.8 11.2033 13.8 8C13.8 4.79675 11.2033 2.2 8 2.2ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8.9461 5.22977C8.9461 5.75216 8.52261 6.17565 8.00022 6.17565C7.47782 6.17565 7.05433 5.75216 7.05433 5.22977C7.05433 4.70737 7.47782 4.28388 8.00022 4.28388C8.52261 4.28388 8.9461 4.70737 8.9461 5.22977Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.91634 7.31857C6.91634 7.09765 7.09542 6.91857 7.31634 6.91857H8.40634C8.62725 6.91857 8.80634 7.09765 8.80634 7.31857V11.3634C8.80634 11.5844 8.62725 11.7634 8.40634 11.7634H7.82592C7.60501 11.7634 7.42592 11.5844 7.42592 11.3634V8.35085C7.42592 8.21013 7.31185 8.09605 7.17113 8.09605C7.03041 8.09605 6.91634 7.98198 6.91634 7.84126V7.31857Z" })
	]
});
export default SvgInformation;
